/** ModuleSidebar.jsx — 모듈 공통 좌측 사이드바 레이아웃 */
import { P, A, G } from "./shared";
import { AccountBadge } from "./AccountSwitch";

var sideW = 180;

var MODULES = {
  collect: {
    title: "📋 자료수집",
    items: [
      { id: "list", icon: "📂", label: "프로젝트 목록" },
      { id: "templates", icon: "📑", label: "템플릿 관리" },
      { id: "collectSettings", icon: "⚙️", label: "설정" },
    ],
  },
  report: {
    title: "📊 가결산 리포트",
    items: [
      { id: "report", icon: "📝", label: "리포트 생성" },
      { id: "reportHistory", icon: "📋", label: "생성 이력" },
      { id: "reportSettings", icon: "⚙️", label: "설정" },
    ],
  },
};

export default function ModuleSidebar({ moduleKey, currentScreen, onNavigate, brandName, userName, children }) {
  var mod = MODULES[moduleKey];
  if (!mod) return children;

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", background: G[50] }}>
      {/* 사이드바 */}
      <div style={{ width: sideW, background: P, display: "flex", flexDirection: "column", flexShrink: 0 }}>
        <div style={{ padding: "14px 14px 10px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: "#fff" }}>{mod.title}</div>
          <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>{brandName || "로움파트너스"}</div>
        </div>
        <div style={{ flex: 1, padding: "6px 0", overflowY: "auto" }}>
          {mod.items.map(function(m) {
            var act = currentScreen === m.id;
            return (
              <div key={m.id} onClick={function() { onNavigate(m.id); }}
                style={{
                  padding: "9px 14px", display: "flex", alignItems: "center", gap: 8,
                  cursor: "pointer", fontSize: 12,
                  background: act ? "rgba(255,255,255,0.12)" : "transparent",
                  borderLeft: act ? "3px solid " + A : "3px solid transparent",
                  color: act ? "#fff" : "rgba(255,255,255,0.6)",
                  fontWeight: act ? 700 : 400,
                }}>
                <span>{m.icon}</span><span>{m.label}</span>
              </div>
            );
          })}
        </div>
        <div style={{ padding: "8px 10px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <button onClick={function() { onNavigate("home"); }}
            style={{
              width: "100%", padding: "7px 8px", borderRadius: 6,
              border: "1px solid rgba(255,255,255,0.15)", background: "transparent",
              color: "rgba(255,255,255,0.6)", fontSize: 11, cursor: "pointer",
            }}>← 홈으로</button>
        </div>
      </div>
      {/* 콘텐츠 */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{
          background: "#fff", borderBottom: "1px solid " + G[200],
          padding: "0 20px", display: "flex", alignItems: "center",
          justifyContent: "space-between", height: 46, flexShrink: 0,
        }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: G[900] }}>
            {(mod.items.find(function(m) { return m.id === currentScreen; }) || {}).icon || ""}{" "}
            {(mod.items.find(function(m) { return m.id === currentScreen; }) || {}).label || mod.title}
          </span>
          <AccountBadge name={userName || ""} style={{ background: "#E8F0FE", color: A }} />
        </div>
        <div style={{ flex: 1, overflow: "auto" }}>
          {children}
        </div>
      </div>
    </div>
  );
}
